import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const paychex = defineConnector({
  identifier: "paychex",
  name: "Paychex",
  tagLine: "Payroll and HR services",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.paychex\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your Paychex API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to the [Paychex Developer Portal](https://developer.paychex.com)
2. Register an application to obtain a client ID and client secret
3. Note your API key for authentication`,
        },
      ],
    },
    {
      title: "Enter your Paychex details",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.paychex.com/auth/oauth/v2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.paychex.com/companies",
  },
});
